module.exports = __webpack_public_path__ + "media/images/frontend/about_first-09014f06dacaecc7531fa9f9fd0b88c3.webp";